/**
 * Local-calendar-date utilities.
 *
 * `Date.prototype.toISOString()` always renders the UTC calendar date. Using it
 * to derive "today" (or any calendar-date-only string) shifts the result by a day
 * whenever the local timezone offset crosses midnight relative to UTC — e.g. in
 * America/Chicago (UTC-5/UTC-6), any local time after 6-7pm reads as "tomorrow"
 * in UTC. These helpers derive the date from LOCAL components instead, so the
 * returned string always matches the calendar date the user is actually on.
 */

function pad2(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}

/**
 * Formats a Date as a `YYYY-MM-DD` string using its LOCAL calendar components
 * (getFullYear/getMonth/getDate), NOT `toISOString()` (which is UTC-anchored).
 */
export function toLocalISODate(date: Date): string {
  const year = date.getFullYear();
  const month = pad2(date.getMonth() + 1);
  const day = pad2(date.getDate());
  return `${year}-${month}-${day}`;
}

/**
 * Returns today's date as a `YYYY-MM-DD` string, anchored to the LOCAL calendar
 * date (not UTC).
 */
export function localTodayISO(): string {
  return toLocalISODate(new Date());
}
